export const picklistIntegers = [];
export const picklistFloats = [];
export const picklistIsoStrings = ['pickReleasedAt'];

export const picklistWhiteList = [
  'id',
  'picklistTemplateId',
  'fromSiteLocationId',
  'toSiteLocationId',
  'pickReleasedByUserId',
  'pickReleased',
  'pickReleasedNotes',
  'pickReleasedAt',
  'picklistNotes',
  'picklistProducts', // FieldArray
  'picklistSupplierCatalogItems', // FieldArray
];
export const picklistOptimisticList = [
  ...picklistWhiteList,
  // 'picklistProducts',
  'picklistTemplate',
  'fromSiteLocation',
  'toSiteLocation',
  // 'picklistSupplierCatalogItems',
  'pickReleasedByUser',
];
